import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import { Globals } from '../../services/tools/Globals.service';
import {Location} from '@angular/common';
/*App imports*/
import { HelpersService } from '../../services/tools/helpers.service';
import { ClientesService } from "../../services/clientes.service";


@Component({
  selector: 'clientes-detalles',
  templateUrl: './clientes-detalles.component.html',
  styleUrls: ['./clientes-detalles.component.scss']
})

export class ClientesDetallesComponent implements OnInit {
  @ViewChild('closeBtn') closeBtn: ElementRef;
    public cliente : any = {};
    public clienteToUpdate : any = {};
    public id : number = null;
    public errors:any = {};
    private sub: any;

  constructor(
    private globals: Globals,
    private route: ActivatedRoute,
    private router: Router,
    private helperService: HelpersService,
    private clientesService: ClientesService,
    public location : Location
    ){

   }

  public ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
        this.id = +params['id'];// (+) converts string 'id' to a number
  
        //Fill Credito data
        this.loadClienteData()
    });  
  }

  private loadClienteData(){
    this.getCliente(this.id, (response)=>
    {
      const cliente = response.json().content;
      this.cliente = cliente;
      
    });
  }

  public showEditModal(){
    this.getCliente(this.id, (response)=>
    {
      const cliente = response.json().content;
      this.clienteToUpdate = cliente;
      
    });
  }

  private getCliente(idClientes : number, fillCliente){
    //TODO: Manejar cuando el id no retorna un crédito valido
    this.clientesService.get(idClientes).subscribe(
      fillCliente, error =>
      {
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);
        
        if(error.status == 400) {
          this.setBackendErrors(error.json().content);
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  public save(){
    this.errors = [];
    this.errors = this.clientesService.validate(this.clienteToUpdate);

    if (Object.entries(this.errors).length > 0) {
      return false;
    }

    this.clientesService.update(this.clienteToUpdate).subscribe(
      (response)=>
      {
        const clientId = response.json().content;
        this.loadClienteData();
        this.helperService.notification('Cliente actualizado', 'Se ha actualizado exitosamente la información del cliente ', 'success');
        this.closeBtn.nativeElement.click();
      }, error =>
      {
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.setBackendErrors(error.json().content);
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  private setBackendErrors(errors:any[]){
    let temp_errors = [];
    
    Object.keys(errors).forEach(function(key){
      temp_errors[key] = errors[key][0];
    });

    this.errors = temp_errors;
  }
}


// WEBPACK FOOTER //
// ./src/app/clientes/detalles/clientes-detalles.component.ts